export enum ProductionJobType {
    SectionSubassembly83AccentWindows = 0,  //obsolete
    SectionSubassembly83AccentDoors = 1,  //obsolete
    SectionSubassembly83Windows = 2,
    SectionSubassembly83OverlayWindows = 3,
    SectionSubassembly83OverlayDoors = 4,
    SectionSubassemblyRibWindows = 36,
    SectionSubassemblyFRAccentWindows = 5,
    SectionSubassemblyFRAccentDoors = 6,
    SectionSubassemblyFRWindows = 7,
    SectionSubassemblyFRDoors = 10,
    SectionSubassemblyFR90 = 25,
    SectionSubassemblyFIP = 11,
    SectionPrint = 12,  //obsolete
    WindowCutoutRaisedPanel = 13,
    WindowCutoutEightyThree = 14,
    WindowCutoutFoamPack = 15,
    WindowCutoutAccentPack = 16,
    WindowCutoutRib = 17,
    SectionAssemblyRP = 18,
    SectionAssembly83 = 19,
    SectionAssemblyFP = 20,
    SectionAssemblyAP = 21,
    SectionAssemblyRB = 22,
    SectionAssemblyFV = 23,
    SectionAssemblyCH = 24,
    HardwareSubassembly = 27,
    SectionLoading = 28,
    TrackSubassemblyResidential = 29,
    TrackSubassemblyCommercial = 30,
    TrackSubassemblyLHR = 31,
    StrutSubassembly = 34,
    SpringSubassemblyResidential = 37,
    SectionPrintWindows = 38,
    SectionPrintDoors = 39,
    SpringSubassemblyCommercial = 40,
    SectionAssemblyI = 41,
    NotApplicable = 99999
}

export const ProductionJobTypeMetadata = {
    '0': {
        display: 'Section Subassembly : 83 : Accent Windows',
        value: 0
    },
    '1': {
        display: 'Section Subassembly : 83 : Accent Doors',
        value: 1
    },
    '2': {
        display: 'Section Subassembly : 83 : Windows',
        value: 2
    },
    '3': {
        display: 'Section Subassembly : 83 : Overlay Windows',
        value: 3
    },
    '4': {
        display: 'Section Subassembly : 83 : Overlay Doors',
        value: 4
    },
    '36': {
        display: 'Section Subassembly : Rib Windows',
        value: 36
    },
    '5': {
        display: 'Section Subassembly : FR : Accent Windows',
        value: 5
    },
    '6': {
        display: 'Section Subassembly : FR : Accent Doors',
        value: 6
    },
    '7': {
        display: 'Section Subassembly : FR : Windows',
        value: 7
    },
    '10': {
        display: 'Section Subassembly : FR : Doors',
        value: 10
    },
    '25': {
        display: 'Section Subassembly : FR : 90',
        value: 25
    },
    '11': {
        display: 'Section Subassembly : FIP',
        value: 11
    },
    '12': {
        display: 'Section : Print',
        value: 12
    },
    '13': {
        display: 'Window : Cutout Raised Panel',
        value: 13
    },
    '14': {
        display: 'Window : Cutout EightyThree',
        value: 14
    },
    '15': {
        display: 'Window : Cutout Foam Pack',
        value: 15
    },
    '16': {
        display: 'Window : Cutout Accent Pack',
        value: 16
    },
    '17': {
        display: 'Window : Cutout Rib',
        value: 17
    },
    '18': {
        display: 'Section Assembly : RP',
        value: 18
    },
    '19': {
        display: 'Section Assembly : 83',
        value: 19
    },
    '20': {
        display: 'Section Assembly : FP',
        value: 20
    },
    '21': {
        display: 'Section Assembly : AP',
        value: 21
    },
    '22': {
        display: 'Section Assembly : RB',
        value: 22
    },
    '23': {
        display: 'Section Assembly : FV',
        value: 23
    },
    '24': {
        display: 'Section Assembly : CH',
        value: 24
    },
    '27': {
        display: 'Hardware Subassembly',
        value: 27
    },
    '28': {
        display: 'Section Loading',
        value: 28
    },
    '29': {
        display: 'Track Subassembly Residential',
        value: 29
    },
    '30': {
        display: 'Track Subassembly Commercial',
        value: 30
    },
    '31': {
        display: 'Track Subassembly LHR',
        value: 31
    },
    '37': {
        display: 'Spring Subassembly Residential',
        value: 37
    },
    '34': {
        display: 'Strut Subassembly',
        value: 34
    },
    '38': {
        display: 'Print Windows',
        value: 38
    },
    '39': {
        display: 'Print Doors',
        value: 39
    },
    '40': {
        display: 'Spring Subassembly Commercial',
        value: 39
    },
    '41': {
        display: 'Section Assembly : I',
        value: 41
    },
    '99999': {
        display: 'NotApplicable',
        value: 99999
    }
};
